import { Component, Input } from '@angular/core';
import { Insurance, PremiumResidence, PrivateLesson, SchoolSupplement, Transfer, TransferServiceType } from '@lx/shared/data-access/products';
import { PremiumActivity } from '@lx/shared/data-access/school';
import { PremiumAccommodationComponent } from '../../../premium-accommodation/premium-accommodation.component';
import { PremiumActivitiesWithOptionsComponent } from '../../../premium-activities-with-options/premium-activities-with-options.component';
import { UnaccompaniedMinorComponent } from '../../../unaccompanied-minor/unaccompanied-minor.component';
import { InsuranceComponent } from '../../../insurance/insurance.component';
import { PrivateLessonComponent } from '../../../private-lesson/private-lesson.component';
import { NgIf } from '@angular/common';
import { TransfersComponent } from '../../../transfers/transfers.component';

@Component({
  standalone: true,
  selector: 'lx-quote-step-juniors-extras',
  templateUrl: './quote-step-juniors-extras.component.html',
  styleUrls: ['./quote-step-juniors-extras.component.scss'],
  imports: [
    PremiumAccommodationComponent,
    PremiumActivitiesWithOptionsComponent,
    UnaccompaniedMinorComponent,
    InsuranceComponent,
    PrivateLessonComponent,
    NgIf,
    TransfersComponent,
  ],
})
export class QuoteStepJuniorsExtrasComponent {
  @Input() insurance: Insurance | undefined;
  @Input() premiumAccommodation: PremiumResidence | undefined;
  @Input() privateLesson: PrivateLesson | undefined;
  @Input() unaccompaniedMinorServices: SchoolSupplement[] | undefined;
  @Input() premiumActivities: PremiumActivity[] | undefined;
  @Input() groupedTransfers: Record<TransferServiceType, Transfer[]> | undefined;
}
